import mainLayout from './mainLayout.vue'
export default mainLayout;